<template lang="pug">
  .cuadro-container
    loading(v-if="isLoading")
    info-card(
      v-if="!isLoading"
      :title="o.titulo"
      :number="o.cantidad"
      :iconClass="o.iconClass"
    )
</template>

<script>
import { apiGet } from '../../util/general';
import InfoCard from '../charts/c_info_card';

export default {
  name: 'cantidad_mis_documentos_sin_firmar',
  components: {
    'info-card': InfoCard
  },
  data () {
    return {
      o: {
        cantidad:'',
        titulo: 'Mis contratos sin firmar',
        iconClass:'fa-pencil'
      },
      isLoading: true
    };
  },
  created () {
    this.fetch();
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
        // to do corregir
        const cantidad = data.lista.filter(a => !a.firmado).length
        if (cantidad === 0) {
          vm.$emit('close')
          return
        }
        vm.o.cantidad = cantidad
      }, function (error) {
        console.error('error', error)
      }, function () {
        vm.isLoading = false
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// c_kpi_cantidad_mis_contratos_sin_firmar.vue?34f1c7ca